__turbopack_context__.v({
  "bottomSheetContent": "Modal-module-scss-module__o5PEPq__bottomSheetContent",
  "fadeInOut": "Modal-module-scss-module__o5PEPq__fadeInOut",
  "large": "Modal-module-scss-module__o5PEPq__large",
  "modalContent": "Modal-module-scss-module__o5PEPq__modalContent",
  "overlay": "Modal-module-scss-module__o5PEPq__overlay",
  "scaleInOut": "Modal-module-scss-module__o5PEPq__scaleInOut",
  "small": "Modal-module-scss-module__o5PEPq__small",
});
